<template>
  <a
    :href="link"
    target="_blank"
    class="w-full md:w-3/12 h-28 px-5 flex-none bg-black rounded-xl bg-opacity-10 hover:bg-opacity-20 flex flex-col justify-center items-center"
    :style="{ minWidth: '260px', borderColor: borderColor }"
  >
    <span class="flex items-center">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-2.5"
      >
        <path
          d="M1 13V14C1 14.7956 1.31607 15.5587 1.87868 16.1213C2.44129 16.6839 3.20435 17 4 17H14C14.7956 17 15.5587 16.6839 16.1213 16.1213C16.6839 15.5587 17 14.7956 17 14V13M13 9L9 13M9 13L5 9M9 13V1"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span>Download program*</span>
    </span>
    <span class="font-montserrat text-sm text-center mt-2 opacity-80">
      *The program may be updated
    </span>
  </a>
</template>

<script setup lang="ts">
import type { Program } from '~/models/program'

interface PropsInterface {
  program: Program
  borderColor?: string
}

const props = withDefaults(defineProps<PropsInterface>(), {
  borderColor: undefined,
})

const printWidth = ref(0)
const printHeight = ref(0)

const link = computed(
  () =>
    `https://panel-api.wnhub.io/pdf/program?id=${props.program.id}&dpi=150&page-height=${printHeight.value}&page-width=${printWidth.value}&margin-top=0&margin-right=0&margin-bottom=0&margin-left=0`
)

onMounted(() => {
  // размеры констант указаны в пикселях
  // генерировалась PDF, устанавливался масштаб 100%, и измерялись размеры в пикселях на экране
  // Ratio служит для перевода пикселей в единицы, которые понимает генератор PDF
  const PRINT_RATIO = 3.78
  const PRINT_COLUMN_WIDTH = 567
  const PRINT_HEADER_HEIGHT = 144
  // const PRINT_FOOTER_HEIGHT = 110
  const PRINT_SECTION_HEIGHT_MIN = 47
  const PRINT_SECTION_HEIGHT_MAX = 110
  const PRINT_SECTION_HEIGHT_AVERAGE =
    (PRINT_SECTION_HEIGHT_MAX + PRINT_SECTION_HEIGHT_MIN) / 2

  let printColumns = 0
  let maxPrintSections = 0

  props.program.days.forEach((day) => {
    day.streams.forEach((stream) => {
      printColumns++
      maxPrintSections = Math.max(maxPrintSections, stream.sections.length)
    })
  })

  const printWidthPx = printColumns * PRINT_COLUMN_WIDTH
  printWidth.value = printWidthPx / PRINT_RATIO

  let printHeightPx =
    PRINT_HEADER_HEIGHT + maxPrintSections * PRINT_SECTION_HEIGHT_AVERAGE
  printHeightPx += PRINT_SECTION_HEIGHT_MIN // добавляем дополнительный отступ снизу, чтобы точно всё поместилось
  printHeight.value = Math.ceil(printHeightPx / PRINT_RATIO)
})
</script>
